/** O que o registro usa do `window.Safe2Pay.Mpi`. */
export interface Mpi3DSListeners {
  addEventListener: (evento: string, callback: (e: unknown) => void) => void
}

export interface Handlers3DS {
  onSuccess: (e: unknown) => void
  onFailure: (e: unknown) => void
  onError: (e: unknown) => void
  /** Cartão sem 3DS ou desconhecido no diretório (`NOT_ENROLLED`/`UNAVAILABLE`). */
  onUnenrolled: (e: unknown) => void
  /** Bandeira não suportada pela autenticação (`UNSUPPORTED_BRAND`). */
  onUnsupportedBrand: (e: unknown) => void
  /** Só ocorre com `IsEnabled: false` no `Init`. */
  onDisabled: (e: unknown) => void
  /** Só ocorre com `IsChallengeSuppressed: true` no `Init`. */
  onChallengeSuppression: (e: unknown) => void
}

/**
 * Eventos do SDK que encerram uma tentativa. Um evento sem listener faz a tela
 * esperar o watchdog; `onReady` e `onTelemetry` são só informativos.
 */
export const EVENTOS_3DS = [
  'onSuccess',
  'onFailure',
  'onError',
  'onUnenrolled',
  'onUnsupportedBrand',
  'onDisabled',
  'onChallengeSuppression',
] as const

export interface RegistroListeners3DS {
  /**
   * Registra os listeners de `EVENTOS_3DS` no `mpi`, se ele ainda não os recebeu.
   * Devolve `false` quando não há SDK.
   */
  garantir: (mpi: Mpi3DSListeners | undefined, handlers: Handlers3DS) => boolean
}

/**
 * O SDK pode carregar depois do mount do componente; registrar só no mount
 * deixava os callbacks mudos. Por isso o registro é refeito sob demanda (antes
 * do `Init` e do `Checkout`) e lembra o objeto que já recebeu os listeners:
 * o mesmo objeto não é registrado de novo, e um objeto novo (SDK recarregado)
 * é. Registrar de novo não duplica handler — o SDK guarda um callback por
 * evento e o substitui.
 */
export default function criarRegistroListeners3DS(): RegistroListeners3DS {
  let registrado: Mpi3DSListeners | null = null

  function garantir(mpi: Mpi3DSListeners | undefined, handlers: Handlers3DS) {
    if (!mpi) return false
    if (mpi === registrado) return true

    EVENTOS_3DS.forEach((evento) => mpi.addEventListener(evento, handlers[evento]))
    registrado = mpi

    return true
  }

  return { garantir }
}
